import { compose, withHandlers, withState } from 'recompose'

const handleImageLoad = props => () => {
  const { setImageLoaded, handleImageLoad: additionalHandler } = props

  setImageLoaded(true)
  if (additionalHandler) additionalHandler()
}

export default () => compose(
  withState('imageLoaded', 'setImageLoaded'),
  withHandlers({ handleImageLoad })
)



// WEBPACK FOOTER //
// ./client/modules/util/withImageLoading.js